<ihd-dropdown-base
    [formControl]="itemControl"
    [dropdownType]="TYPE_DROPDOWN"
    [placeholder]="placeholder"
    [popoverWidth]="popoverWidth"
    [displayKey]="displayKey"
    [tabindex]="tabindex"
    [displayFn]="displayFn"
    [disabled]="disabled"
    (change)="dropdownChange($event)"
>
    <ihd-option
        *ngFor="let item of items; let i = index"
        [value]="item"
        [disabled]="item?.disabled"
        [id]="item[itemId]"
    >
        {{ item[displayKey] | translate }}
    </ihd-option>
</ihd-dropdown-base>
